import { Text } from '@chakra-ui/react'
import React from 'react'

import { FilterOption, FilterOptionWrapper } from './SnippetSettingsStyles'

interface FilterMenuProps {
  options: {
    label: string
    value: string
    default?: boolean
    disabled?: boolean
  }[]
  onChange: (value: string) => void
  selectedFilter: string
}

const FilterMenu = ({ options, onChange, selectedFilter }: FilterMenuProps) => {
  return (
    <FilterOptionWrapper>
      {options.map(({ value, label }) => {
        const isSelected = selectedFilter === value
        return (
          <FilterOption
            key={value}
            onClick={() => onChange(value)}
            isSelected={isSelected}
          >
            <Text
              color="black"
              fontSize="sm"
              fontWeight={isSelected ? 'bold' : 'normal'}
            >
              {label}
            </Text>
          </FilterOption>
        )
      })}
    </FilterOptionWrapper>
  )
}

export default FilterMenu
